<template>
  <v-btn
    :id="id"
    class="radio-btn"
    :style="cssVars"
    :ripple="false"
    active-class="selected"
  >
    {{ label }}
  </v-btn>
</template>

<script>
export default {
  props: {
    disabled: Boolean,
    id: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    error: Boolean,
    readonly: Boolean,
    value: {
      type: [String, Number, Boolean, Object],
      default: ''
    },
  },
  computed: {
    cssVars() {
      return {
        '--icon-inactive': 'url('+this.imgUrl(this.icon+'_inactive.svg')+')',
        '--icon-active': 'url('+this.imgUrl(this.icon+'_active.svg')+')',
        '--error': this.error ? '#DB2435' : '#a9a9a9'
      };
    },
  },
  methods: {
    imgUrl(img) {
      return require('../../../../../assets/images/' + img)
    },
  }
};
</script>

<style lang="scss" scoped>

.radio-btn {
  background: var(--icon-inactive) no-repeat;
  background-position: 50% 30%;
  height: 108px !important;
  letter-spacing: 0px;
  text-transform: none;
  background-color: #ffffff !important;
  position: relative;
  display: inline-flex;
  width: 100%;
  font: normal normal normal 12px/17px Open Sans;
  margin-bottom: 15px;
  color: #073F60;
  border: 2px solid var(--error);
  border-radius: 5px;
  text-align: center;
  box-shadow: none;
  padding: 0%;

  ::v-deep .v-btn__content {
    display: block;
    padding: 75px 0px 0px 0px;
  }

  &:hover {
    box-shadow: 0 0 8px #007EB1;
    color: #FFFF;
    background: var(--icon-active) no-repeat;
    background-position: 50% 30%;
    font-weight: bold;

    ::v-deep .v-btn__content {
      color: #007EB1;
    }
  }

  &:focus,
  &:active {
    border: 2px solid #007EB1 !important;
    color: #FFFF;
    background: var(--icon-active) no-repeat;
    background-position: 50% 30%;
    font-weight: bold;

    ::v-deep .v-btn__content {
      color: #007EB1;
    }
  }

  &:disabled {
    background: var(--icon-inactive) no-repeat;
    background-position: 50% 30%;
    font-weight: normal;
    color: #073F60;
    border: 2px solid #a9a9a9;
    border-radius: 5px;
  }
}

.selected {
  border: 2px solid #007EB1 !important;
  color: #FFFF;
  background: var(--icon-active) no-repeat;
  background-position: 50% 30%;
  font-weight: bold;

  ::v-deep .v-btn__content {
    color: #007EB1;
  }
}

</style>
